<div class="breadcrumb-container">
  @let breadcrumbsVal = breadcrumbs();
  @if (breadcrumbsVal) {
    <ul class="breadcrumb-list"> <!-- TODO: handle "smart" ellipsis (as in https://codepen.io/shippin/pen/YrwrYa) -->
      @for (breadcrumb of breadcrumbsVal; track $index; let last = $last, first = $first) {
        @if (!first) {
          <li class="breadcrumb-item separator" [ngClass]="{ 'active': last }">
            <i class="ph ph-caret-right separator-icon"></i>
          </li>
        }
        <li
          class="breadcrumb-item"
          [ngClass]="{ 'active': last, 'routable': breadcrumb.navigateTo }"
          (click)="onElementClick(breadcrumb)"
          [algTooltip]="breadcrumb.title"
          tooltipPosition="bottom"
          tooltipStyleClass="secondary"
        >
          <span class="label">{{ breadcrumb.title }}</span>
        </li>
      }
    </ul>
  }
</div>
